import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CandidateDetails from "./candidateDetails";
import FilterListIcon from "@mui/icons-material/FilterList";
import AdvanceFilter from "./advanceFilter";
import ModalLoadingOverlay, {
  modalLoadingContainerSx,
} from "./ModalLoadingOverlay";
import { generate_filter_condition } from "../utiles/filter";
import { onGlobalFliterFunc } from "../utiles/onFilterChange";
import Cookies from "js-cookie";
import DynamicDataGrid from "./dynamicDataGrid";
import { MarginRounded } from "@mui/icons-material";

const Applicants = (props) => {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const statusPermission = PermissionStatus["100"];
  const { id } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const debounceRef = useRef(null);
  const [applicants, setApplicantsdata] = useState([]);
  // ── STATUS dropdown anchor (replaces ButtonGroup/Popper) ──
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const statusMenuOpen = Boolean(statusAnchorEl);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [status, setstatus] = useState([]);
  const [isApplicanOpen, setApplicanOpen] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [candidateid, setCandidateId] = useState([]);
  const [checkboxSelected, setcheckboxSelected] = useState(true);
  const [verifiedstatus, setverifiedstatus] = useState("");
  const [refreshagain, setrefreshagain] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [statusSubmitting, setStatusSubmitting] = useState(false);
  const [comment, setComment] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
  const [opennew, setOpennew] = React.useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [rerenderKey, setRerenderKey] = useState(0);
  const [searchTermPrev, setSearchTermPrev] = useState("");
  const [queryOptions, setQueryOptions] = useState({});
  const [datemodified, setdatemodified] = useState("");
  const [candidateIdDate, setCandidateIdDate] = useState([]);
  const questionsrequired = props.questionrequired;
  const [FilterHitting, setFilterHitting] = useState(false);
  const [advanceFilter, setAdvanceFilter] = useState(false);
  const [question, setQuestion] = useState([]);
  const [quesAnsArrayFilter, setQuesAnsArrayFilter] = useState([]);
  const [current, setCurrent] = useState([]);
  const [myArray, setArray] = useState([]);
  const [textFields, setTextFields] = useState({});
  const [radioValues, setRadioValues] = useState({});
  const [operatorValues, setOperatorValues] = useState({});
  const [checkboxValues, setCheckboxValues] = useState({});
  const [checkedCount, setCheckedCount] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [filterOptions, filtersetQueryOptions] = React.useState({
    filterModel: null,
  });
  const [selectedCount, setSelectedCount] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [candidateList, setCandidateList] = useState([]);
  const [createdby, setCreatedby] = useState("");
  const [newData, setNewData] = useState([]);
  const [cancelData, setCancelData] = useState(false);
  const [username, setUsername] = useState("");
  const [newCount, setNewCount] = useState(0);
  const [testingdata, setTestingdta] = useState([]);

  const getUserData = async () => {
    const user_id = localStorage.getItem("user_id");
    const candidateOwnerList = await axios.get(`active-users/${user_id}`, {
      headers: {
        authorization:
          Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
      },
    });
    setCandidateList(candidateOwnerList.data.message);
    setUsername("Select User Name");
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handleSelectionData = (event, value, reason) => {
    setSelectedOptions(value);
    setSelectedCount(value.length);
    const usernames = value?.map((item) => item.name);
    const filterCondition = generate_filter_condition(
      "and candidate_info.entered_by",
      "isAnyOf",
      usernames,
    );
    if (usernames.length > 0) setCreatedby(filterCondition);
    else setCreatedby("");
    if (reason === "clear") {
      setCreatedby("");
      setCancelData(true);
    }
    if (reason === "removeOption") setCancelData(true);
  };

  const handleCheckboxChange = (e, id, index) => {
    const checked = e.target.checked;
    setCheckboxValues((prev) => ({ ...prev, [id]: checked }));
    let tempArr = [...quesAnsArrayFilter];
    tempArr[index].isChecked = checked;
    if (checked) {
      setQuesAnsArrayFilter(tempArr);
    } else {
      tempArr[index].ans_text = "";
      tempArr[index].errorText = null;
      const updatedTextFields = { ...textFields };
      updatedTextFields[id] = "";
      setTextFields(updatedTextFields);
      const updatedRadioValues = { ...radioValues };
      updatedRadioValues[id] = "";
      setRadioValues(updatedRadioValues);
      setQuesAnsArrayFilter(tempArr);
    }
    setCheckedCount(quesAnsArrayFilter.filter((item) => item.isChecked).length);
  };

  const handleOperatorValuesChange = (e, id, index) => {
    const { value } = e.target;
    setOperatorValues((prev) => ({ ...prev, [id]: value }));
    let tempArr = [...quesAnsArrayFilter];
    tempArr[index].operator = value;
    setQuesAnsArrayFilter(tempArr);
  };

  const temp = (value, type) => {
    if (type === "tel") {
      if (value.length === 0) return "This field is required";
      else if (value.trim().length >= 13) return "Maximum 12 digits allowed";
      else return null;
    }
  };

  const handleTextFieldChange = (e, id, index) => {
    const { value, type } = e.target;
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    setTextFields((prev) => ({ ...prev, [id]: capitalizedValue }));
    let tempArr = [...quesAnsArrayFilter];
    if (tempArr[index].isChecked === true) {
      tempArr[index].ans_text = capitalizedValue;
      tempArr[index].operator = quesAnsArrayFilter[index].operator
        ? quesAnsArrayFilter[index].operator
        : "=";
      tempArr[index].errorText = temp(capitalizedValue, type);
    } else {
      tempArr[index].errorText = null;
      tempArr[index].operator = "";
      tempArr[index].ans_text = "";
    }
    setQuesAnsArrayFilter(tempArr);
  };

  const handleRadioChange = (e, id, index) => {
    const { value } = e.target;
    setRadioValues((prev) => ({ ...prev, [id]: value }));
    let tempArr = [...quesAnsArrayFilter];
    if (tempArr[index].isChecked === true) {
      tempArr[index].operator = quesAnsArrayFilter[index].operator
        ? quesAnsArrayFilter[index].operator
        : "";
      tempArr[index].errorText = null;
      tempArr[index].ans_text = value;
    } else {
      tempArr[index].errorText = null;
      tempArr[index].operator = "=";
      tempArr[index].ans_text = "";
    }
    setQuesAnsArrayFilter(tempArr);
  };

  const handleAdvanceFilterOpen = () => {
    setNewData(selectedOptions);
    let mytemp = current.map((q) => ({ ...q }));
    const updatedValues = {},
      updatedText = {},
      updatedRadioValues = {},
      updatedOperator = {};
    mytemp.forEach((question) => {
      updatedText[question.question_id] = question.ans_text;
      updatedRadioValues[question.question_id] = question.ans_text;
      updatedOperator[question.question_id] = question.operator;
      if (question.isChecked !== undefined)
        updatedValues[question.question_id] = question.isChecked;
    });
    setOperatorValues((prev) => ({ ...prev, ...updatedOperator }));
    setRadioValues((prev) => ({ ...prev, ...updatedRadioValues }));
    setTextFields((prev) => ({ ...prev, ...updatedText }));
    setCheckboxValues((prev) => ({ ...prev, ...updatedValues }));
    setQuesAnsArrayFilter([...mytemp]);
    if (cancelData) setSelectedCount(newData.length);
    setAdvanceFilter(true);
  };

  const handleAdvanceFilterClose = () => {
    setAdvanceFilter(false);
    selectedOptions.length > 0 || cancelData
      ? setSelectedOptions(newData)
      : setSelectedOptions([]);
  };

  const handleFilterReset = () => {
    setTextFields({});
    setRadioValues({});
    setCheckboxValues({});
    setCheckedCount(0);
    setNewCount(0);
    const a = quesAnsArrayFilter.map((q) => ({
      type_id: q.type_id,
      question_id: q.question_id,
      ans_text: "",
      errorText: null,
      operator: "=",
      isChecked: false,
    }));
    setQuesAnsArrayFilter(a);
    setIsReset(true);
    setCurrent(a);
    setAdvanceFilter(false);
    setFilterHitting(false);
    setrefreshagain(!refreshagain);
    setSelectedOptions([]);
    setCreatedby("");
  };

  const validate = () => {
    let isValid = true;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.type_id === 2 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "This field is required";
          isValid = false;
        } else if (item.ans_text.length > 12) {
          item.errorText = "Maximum 12 digits allowed";
          isValid = false;
        } else item.errorText = null;
      } else if (item.type_id === 3 && item.isChecked) {
        if (item.ans_text === "") {
          item.errorText = "Please select an option";
          isValid = false;
        } else item.errorText = null;
      } else item.errorText = null;
    });
    setQuesAnsArrayFilter(updateArray);
    return isValid;
  };

  const handleAdvanceFilterApply = () => {
    setAdvanceFilter(!validate());
    let error = 0;
    let updateArray = [...quesAnsArrayFilter];
    updateArray.forEach((item) => {
      if (item.isChecked) {
        if (item.type_id === 2 && item.ans_text === "") {
          error = 1;
          item.errorText = "This field is required";
        } else if (item.type_id === 3 && item.ans_text === "") {
          error = 1;
          item.errorText = "Please select an option";
        }
      }
    });
    if (!error) {
      let mytemp = quesAnsArrayFilter.map((q) => ({ ...q }));
      const countChecked = mytemp.filter((item) => item.isChecked).length;
      setCheckedCount(countChecked);
      setNewCount(selectedCount > 0 ? countChecked + 1 : countChecked);
      setCurrent([...mytemp]);
      setFilterHitting(true);
      setrefreshagain(!refreshagain);
    }
  };

  const handleSortModelChange = React.useCallback((sortModel) => {
    setQueryOptions({ sortModel: [...sortModel] });
  }, []);

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };
  const handleSnackbarClose = () => setOpenSnackbar(false);

  const onFilterChange = React.useCallback((filterModel) => {
    const respFilterData = onGlobalFliterFunc(
      filterModel,
      `and concat(u.first_name, ' ', u.last_name)`,
    );
    if (respFilterData) filtersetQueryOptions(respFilterData);
  }, []);

  const FilterPayload = quesAnsArrayFilter.filter((item) => item.isChecked);

  useEffect(() => {
    setShowLoader(true);
    let payload = {
      jobId: id,
      isShortlisted: 0,
      pageSize: paginationModel.pageSize,
      quesAnsArray: !FilterHitting ? [] : FilterPayload ? FilterPayload : [],
      filterCriteria: createdby
        ? createdby.includes("and candidate_info.entered_by in ()")
          ? ""
          : createdby
        : "",
      filter:
        FilterHitting && FilterPayload && checkedCount > 0 ? "true" : "false",
    };
    if (queryOptions.sortModel && queryOptions.sortModel.length > 0) {
      payload.sortField = queryOptions?.sortModel[0].field;
      payload.sortBy = queryOptions?.sortModel[0].sort;
    }
    if (!validate()) return;
    axios
      .post(
        `job-applicants/${(searchTermPrev && searchTermPrev !== debouncedSearch) || isReset ? 1 : paginationModel.page + 1}${debouncedSearch ? "?search=" + debouncedSearch : ""}`,
        payload,
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        const filteredApplicants = response.data.message.data.filter(
          (a) => a.id !== null,
        );
        setApplicantsdata(filteredApplicants);
        setTestingdta(filteredApplicants);
        setShowLoader(false);
        setSearchTermPrev(debouncedSearch);
        setTotalCount(response.data.message.page);
        setIsReset(false);
      })
      .catch((err) => {
        setShowLoader(false);
        setApplicantsdata([]);
        console.error(err);
      });
  }, [
    isDrawerOpen,
    refreshagain,
    paginationModel,
    queryOptions,
    debouncedSearch,
    filterOptions,
  ]);

  useEffect(() => {
    axios
      .get(`candidate/job-status`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => setstatus(response.data.message))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const HandleRowClick = (row) => {
    setverifiedstatus(row.isVerified);
    setSelectedRowData(row);
    setApplicanOpen(true);
  };

  const filteredApplicants = applicants.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const handleSelection = (params) => {
    const rowData = filteredApplicants.filter((e) => params.includes(e.id));
    const newdata = rowData.map((e) => ({
      id: e.id,
      date_modified: e.date_modified,
    }));
    setcheckboxSelected(true);
    setIsCheckboxSelected(!!params.length);
    setCandidateId(params);
    setCandidateIdDate(newdata);
  };

  const saveCommentAndStatus = () => {
    setStatusSubmitting(true);
    axios
      .post(
        `change-candidate-job-status`,
        {
          candidate_ids: candidateIdDate,
          job_id: Number(id),
          status: selectedStatus,
          comment,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleSnackbarOpen("Candidate Status Changed Successfully");
          closeDialog();
          setRerenderKey((prev) => prev + 1);
          setrefreshagain(!refreshagain);
          setIsCheckboxSelected(false);
        }
      })
      .catch((err) => {
        handleSnackbarOpen(err.response.data.error);
        closeDialog();
      })
      .finally(() => {
        setStatusSubmitting(false);
      });
  };

  // ── STATUS dropdown handlers ───────────────────────────────────────────────
  const handleStatusButtonClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };
  const handleStatusMenuClose = () => {
    setStatusAnchorEl(null);
  };
  const handleMenuItemClick = (event, index, item) => {
    setSelectedIndex(index);
    setSelectedStatus(item);
    setStatusAnchorEl(null);
    openDialog();
  };
  // ──────────────────────────────────────────────────────────────────────────

  const handleOnClose = () => {
    setApplicanOpen(false);
    setOpennew((prev) => !prev);
  };

  const checkDisabled = () => {
    const newArr = filteredApplicants.filter((e) => candidateid.includes(e.id));
    return newArr.filter((e) => e.status !== "Withdrawn").length > 0
      ? false
      : true;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: 2,
        position: "relative",
      }}
    >
      {/* ── Toolbar ── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Typography variant="h6" fontWeight={700} sx={{ fontSize: "16px" }}>
          Applicants
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {/* Search */}
          <TextField
            size="small"
            type="search"
            placeholder="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setSearchTerm(value); // UI input turant update ho
              if (debounceRef.current) clearTimeout(debounceRef.current);
              debounceRef.current = setTimeout(() => {
                setDebouncedSearch(value); // API call 500ms baad
              }, 500);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" sx={{ color: "#667085" }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: "8px",
                fontSize: "0.875rem",
                height: "32px",
                backgroundColor: "background.paper",
              },
            }}
            sx={{ width: "200px" }}
          />

          {/* ── STATUS — normal dropdown button (replaces split ButtonGroup) ── */}
          {statusPermission?.add === 1 && (
            <>
              <Button
                variant="contained"
                size="small"
                disabled={
                  !isCheckboxSelected ||
                  props.status === "Closed" ||
                  props.status === "Cancelled" ||
                  props.status === "Full"
                }
                endIcon={<ArrowDropDownIcon />}
                onClick={handleStatusButtonClick}
                sx={{
                  height: "32px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.8rem",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  boxShadow: "none",
                  "&:hover": { backgroundColor: "#1565c0", boxShadow: "none" },
                  "&.Mui-disabled": {
                    backgroundColor: "#1976d2",
                    opacity: 0.5,
                    color: "#fff",
                  },
                }}
              >
                STATUS
              </Button>

              {/* Dropdown Menu */}
              <Menu
                anchorEl={statusAnchorEl}
                open={statusMenuOpen}
                onClose={handleStatusMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{
                  elevation: 3,
                  sx: { borderRadius: "8px", mt: 0.5 },
                }}
              >
                {status.map((option, index) => (
                  <MenuItem
                    key={option.status}
                    disabled={checkDisabled()}
                    onClick={(event) =>
                      handleMenuItemClick(event, index, option.status)
                    }
                    sx={{ fontSize: "14px" }}
                  >
                    {option.status}
                  </MenuItem>
                ))}
              </Menu>

              {/* Change Status dialog */}
              <Dialog
                open={isDialogOpen}
                fullWidth
                PaperProps={{
                  sx: modalLoadingContainerSx(statusSubmitting),
                }}
              >
                <DialogTitle>Change Status</DialogTitle>
                <Divider />
                <DialogContent>
                  <Typography variant="body1" className="fw-500" gutterBottom>
                    Add Comment
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Comment"
                    variant="outlined"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </DialogContent>
                <Divider />
                <Typography
                  style={{ padding: "16px" }}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Button
                    className="cancel-btn"
                    variant="text"
                    color="primary"
                    onClick={closeDialog}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={saveCommentAndStatus}
                  >
                    Save
                  </Button>
                </Typography>
                <ModalLoadingOverlay open={statusSubmitting} />
              </Dialog>
            </>
          )}

          {/* Filter button */}
          <Button
            variant="outlined"
            size="small"
            onClick={handleAdvanceFilterOpen}
            startIcon={<img src="/assets/filter.svg" alt="" />}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.85rem",
              height: "32px",
              borderRadius: "8px",
              borderColor: "divider",
              color: "text.primary",
              backgroundColor: "background.paper",
              "&:hover": {
                borderColor: "text.secondary",
                backgroundColor: "action.hover",
              },
              gap: 0.5,
              "& .MuiButton-startIcon": {
                marginRight: "0",
              },
            }}
          >
            FILTER
            {newCount > 0 && (
              <Box
                component="span"
                sx={{
                  ml: 0.5,
                  backgroundColor: "#1976d2",
                  color: "white",
                  borderRadius: "50px",
                  px: "7px",
                  py: "1px",
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
              >
                {newCount}
              </Box>
            )}
          </Button>
        </Box>
      </Box>

      {/* AdvanceFilter — absolute overlay, anchored below toolbar */}
      {advanceFilter && (
        <Box
          sx={{
            position: "absolute",
            top: "48px",
            right: 0,
            zIndex: 1200,
          }}
        >
          <AdvanceFilter
            advanceFilter={advanceFilter}
            handleAdvanceFilterOpen={handleAdvanceFilterOpen}
            handleAdvanceFilterClose={handleAdvanceFilterClose}
            handleAdvanceFilterApply={handleAdvanceFilterApply}
            handleFilterReset={handleFilterReset}
            question={question}
            setQuestion={setQuestion}
            textFields={textFields}
            setTextFields={setTextFields}
            radioValues={radioValues}
            setRadioValues={setRadioValues}
            operatorValues={operatorValues}
            setOperatorValues={setOperatorValues}
            checkboxValues={checkboxValues}
            setCheckboxValues={setCheckboxValues}
            handleOperatorValuesChange={handleOperatorValuesChange}
            handleCheckboxChange={handleCheckboxChange}
            handleTextFieldChange={handleTextFieldChange}
            handleRadioChange={handleRadioChange}
            quesAnsArrayFilter={quesAnsArrayFilter}
            setQuesAnsArrayFilter={setQuesAnsArrayFilter}
            current={current}
            setCurrent={setCurrent}
            setArray={setArray}
            selectedCount={selectedCount}
            selectedOptions={selectedOptions}
            handleSelectionData={handleSelectionData}
            candidateList={candidateList}
            username={username}
          />
        </Box>
      )}

      {/* Table */}
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <DynamicDataGrid
          rows={applicants}
          loading={showLoader}
          showCheckbox={statusPermission?.add === 1}
          name={"Applicants"}
          onRowSelection={HandleRowClick}
          onRowSelectionModelChange={handleSelection}
          totalRows={totalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>

      <CandidateDetails
        isOpen={isApplicanOpen}
        onClose={handleOnClose}
        opennew={opennew}
        setOpennew={setOpennew}
        selectedRowData={selectedRowData}
        Jobstatus={props.status}
        testingdata={testingdata}
        setrefreshagain={setrefreshagain}
        refreshagain={refreshagain}
        issearchnavbar={false}
        responsehide={props.questionrequired ? true : false}
      />

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Applicants;
